import { computed, get } from '@ember/object';

export default function selectFromObject(objectKey, itemKey) {
  return computed(objectKey, itemKey, function () {
    return get(this, `${objectKey}.${get(this, itemKey)}`);
  });
}
